import pushGTMEvent from '@helpers/analyticsHelpers/pushGTMEvent';

export const trackLoadMore = (storeType: onlineOfflineType) => {
  pushGTMEvent({
    event: 'Track',
    category: storeType === 'offline' ? 'offers_page_store' : 'offers_page_ecommerce',
    action: 'show_all_products',
    label: '',
    value: 0,
  });
};

export const trackFlyerSelected = (label: 'current_week_flyer' | 'next_week_flyer') => {
  pushGTMEvent({
    event: 'Track',
    category: 'promotion_page',
    action: 'flyer_selected',
    label,
    value: 0,
  });
};

export const trackStickyDeliveryPicker = (label: string) => {
  pushGTMEvent({
    event: 'Track',
    category: 'sticky_bar',
    action: 'change_promotionpage',
    label,
    value: 0,
  });
};
